import React from 'react';
import { Modal, Container, Row, Col } from 'react-bootstrap';
import { BaseProductAttributes } from '../../components/AmazonInventory/BaseProductAttributes';
import { RegionalPricing } from '../../components/AmazonInventory/RegionalPricing';
import Flag from 'react-flagkit';
import { SetAllButton } from '../../components/AmazonInventory/SetAllButton';
import { SelectAllRegions } from '../../components/AmazonInventory/SelectAllRegions';
import { regions } from '../../data/regions';

import { ApproveButton } from '../../components/AmazonInventory/ApproveButton';

export const FullScreenPricesModal = (props) => {
  function onHideModal() {
    let confirmed = true;
    if (JSON.stringify(props.cachedSelectedRows) !== JSON.stringify(props.selectedRows)) {
      confirmed = window.confirm('Are you sure you want to exit without saving?');
    }
    if (!confirmed) {
      return;
    }
    props.setShow(false);
    props.updateStateOnHideModal(props.cachedSelectedRows);
    //if (props.selectedRows.length === 1) {
    //props.setSelectedRows([]);
    //}
  }

  //chunk regions into rows of 2 for display
  const regionChunks = [];
  for (let i = 0; i < regions.length; i += 2) {
    const chunk = regions.slice(i, i + 2);
    regionChunks.push(chunk);
  }

  return (
    <>
      <Modal show={props.show} dialogClassName='full-screen-modal' onHide={() => onHideModal()}>
        <Modal.Header closeButton>
          <Modal.Title>Edit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <Row>
              <Col xs={11}>
                <BaseProductAttributes
                  selectedRows={props.selectedRows}
                  setSelectedProductObj={props.setSelectedRows}
                  updateBaseProductAttribute={(e, index, tableData) => {
                    props.updateBaseProductAttribute(e, index, props.originalProductData);
                  }}
                  recalculateFromBasePrices={props.recalculateFromBasePrices}
                />
              </Col>
              {props.show && (
                <Col xs={1}>
                  <div>
                    {props.selectedRows[0].approved && (
                      <ApproveButton
                        cachedSelectedRows={props.cachedSelectedRows}
                        setCachedSelectedRows={props.setCachedSelectedRows}
                        selectedRows={props.selectedRows}
                        approvedStatus={props.selectedRows[0].approved}
                        action={'save'}
                        updateBaseProductAttribute={(e, index) => {
                          props.updateBaseProductAttribute(e, index);
                        }}
                      />
                    )}
                  </div>

                  <div>
                    {props.selectedRows.length <= 1 && !props.selectedRows[0].approved && (
                      <ApproveButton
                        cachedSelectedRows={props.cachedSelectedRows}
                        setCachedSelectedRows={props.setCachedSelectedRows}
                        selectedRows={props.selectedRows}
                        approvedStatus={props.selectedRows[0].approved}
                        action={'approve'}
                        updateBaseProductAttribute={(e, index) => {
                          props.updateBaseProductAttribute(e, index);
                        }}
                      />
                    )}
                  </div>
                </Col>
              )}
            </Row>
            <Row className='mt-3'>
              <Col xs={12}>
                <Row>
                  <Col xs={1}>
                    <SetAllButton
                      text='Set selected min price'
                      name='minPrice'
                      products={props.selectedRows}
                      updateRegionalProductAttribute={props.updateRegionalProductAttribute}
                      selectedRegions={props.selectedRegions}
                    ></SetAllButton>
                  </Col>
                  <Col xs={1}>
                    <SetAllButton
                      text='Set selected max price'
                      name='maxPrice'
                      products={props.selectedRows}
                      updateRegionalProductAttribute={props.updateRegionalProductAttribute}
                      selectedRegions={props.selectedRegions}
                    ></SetAllButton>
                  </Col>
                  <Col xs={1}>
                    <SetAllButton
                      text='Set selected min margin'
                      name='minTargetMargin'
                      products={props.selectedRows}
                      updateRegionalProductAttribute={props.updateRegionalProductAttribute}
                      selectedRegions={props.selectedRegions}
                    ></SetAllButton>
                  </Col>
                  <Col xs={1}>
                    <SetAllButton
                      text='Set selected max margin'
                      name='maxTargetMargin'
                      products={props.selectedRows}
                      updateRegionalProductAttribute={props.updateRegionalProductAttribute}
                      selectedRegions={props.selectedRegions}
                    ></SetAllButton>
                  </Col>
                  <Col xs={1}>
                    <SetAllButton
                      text='Lock selected'
                      name='lockButton'
                      products={props.selectedRows}
                      updateRegionalProductAttribute={props.updateRegionalProductAttribute}
                      selectedRegions={props.selectedRegions}
                    ></SetAllButton>
                  </Col>
                  <Col xs={1}>
                    <SetAllButton
                      text='Unlock selected'
                      name='unlockButton'
                      products={props.selectedRows}
                      updateRegionalProductAttribute={props.updateRegionalProductAttribute}
                      selectedRegions={props.selectedRegions}
                    ></SetAllButton>
                  </Col>
                  <Col xs={1}>
                    <SetAllButton
                      text='Set selected PPP ID'
                      name='strategyId'
                      products={props.selectedRows}
                      updateRegionalProductAttribute={props.updateRegionalProductAttribute}
                      selectedRegions={props.selectedRegions}
                    ></SetAllButton>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className='d-flex'>
              <div>
                <SelectAllRegions setSelectedRegions={props.setSelectedRegions}></SelectAllRegions>
              </div>
              <div className='ms-3'></div>
            </div>
          </Container>
          <Container fluid>
            {regionChunks.map((regionArr, index) => {
              return (
                <Row key={index}>
                  {regionArr.map((region) => {
                    return (
                      <Col key={region}>
                        <div className='mb-2'>
                          <div>
                            <h2>
                              <Flag country={region.toUpperCase()} size={32} /> {region.toUpperCase()}
                            </h2>
                          </div>
                          <RegionalPricing
                            products={props.selectedRows}
                            region={region}
                            updateRegionalProductAttribute={(e, region, index, value) => {
                              props.updateRegionalProductAttribute(e, region, index, value);
                            }}
                            updateRegionArr={props.updateRegionArr}
                            selectedRegions={props.selectedRegions}
                          />
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              );
            })}
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};
